import configure from "./configure.json";
import dashboard from "./dashboard.json";
import listpatient from "./listpatient.json"

const translations = {
  configure,
  dashboard,
  listpatient
};

export default translations;
